import { Time } from '../types/time.type';
import { CommonUtils } from '../tool/common-utils';

export class DateTime {
  public date: Date;
  public time: Time;

  constructor(date: Date, time: Time) {
    this.date = date;
    this.time = time;
  }

  public serialize(): { date: string; time: string } {
    let date: string = null;
    let time: string = null;
    if (this.date) {
      date = CommonUtils.convertDateToString(this.date);
    }
    if (this.time) {
      time = CommonUtils.convertTimeToString(this.time);
    }
    return {
      date: date,
      time: time,
    };
  }
}
